import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { PlessSharedModule } from './pless-shared.module';
import { UploadFileSeletComponent } from './upload-file-select/upload-file-select.component';
import { ToggleIconButtonComponent } from './input/toggle-icon-button.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjNavModule,
    WjGridModule,
    PlessSharedModule,
  ],
  exports: [
    ToggleIconButtonComponent,
  ],
  declarations: [
    UploadFileSeletComponent,
    ToggleIconButtonComponent,
  ],
  providers: [
  ],
})

/** 共通機能を管理するモジュール */
export class SharedModule {}
